import { cloneDeep } from 'lodash/lang'

const setRefundRecipientForm = (state, action) => {
  const { refundRecipient } = action

  // TODO: add default form fields
  return cloneDeep(refundRecipient)
}

export default setRefundRecipientForm
